var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('h3',{staticClass:"mb-2 text-center text-h3",class:{ 'sr-only': !_vm.showTitle }},[_vm._v(" "+_vm._s(_vm.page.title)+" ")]),_c('v-container',{ref:"content",staticClass:"page-content",domProps:{"innerHTML":_vm._s(_vm.page.content)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }